import { connect } from 'react-redux';
import LoginNotAllowed from './LoginNotAllowed';
import { clearSession, identifyUserFailureAccessNotAllowedByEmployerUserNoted } from '../../actions/session';

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  clearSession: dispatch(clearSession),
  close() {
    dispatch(identifyUserFailureAccessNotAllowedByEmployerUserNoted());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginNotAllowed);



// WEBPACK FOOTER //
// ./src/containers/LoginNotAllowed/index.js